import axios from 'axios'

export default  {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    search({commit}, params) {
      return new Promise((resolve, reject) => {
        axios.get('exams/exam-samples/search', {
          params,
        })
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    fixExamResult({ commit }, examResult) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/exams/exam-samples/fix-exam-result`, examResult)
          .then(res => {
            resolve(res.data.data.appointment)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    processStatus({commit}, sampleTrackingData) {
      return new Promise((resolve, reject) => {
        axios
          .post('exams/exam-samples/process-status', sampleTrackingData)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    saveSampleResult({commit}, sampleResultData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/exams/exam-samples/${sampleResultData.exam_sample_id}/update-sample-result`, sampleResultData)
          .then(res => {
            resolve(res.data.data.sampleResult)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },

  getters: {},
}
